/**
 * Public social links (Footer, Contact page).
 * Canonical CMS path: contact.socialNetworks.networks
 *
 * global.socialMedia flat keys (facebook, instagram, etc.) are legacy;
 * WhatsApp routing uses global.socialMedia.whatsappNumbers via utils/whatsapp.js.
 */
export function getSocialNetworks(getContent) {
  const section =
    typeof getContent === 'function'
      ? getContent('contact.socialNetworks') || {}
      : getContent || {};

  return (section.networks || []).filter((n) => String(n?.url || '').trim());
}
